import { isEqual } from 'lodash';
import router from 'next/router';

export function scrollDown(scrollPosition: number) {
  window.scrollTo({
    top: scrollPosition
  });
}

export function redirectLink(
  itemLabel: string,
  route: string,
  scrollPosition: number
) {
  if (isEqual(itemLabel, 'View Our Brochure')) {
    window.open(route);
  } else {
    router.push(route);
    router.events.on('routeChangeComplete', () => scrollDown(scrollPosition));
  }
}
